import React, { useState, useRef } from 'react';
import { Modal, Button, InputGroup, FormControl } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ProductsClient } from '../web-api-client.ts';

function ScanModal({ show, onClose, onBarcodeDetected }) {
  const [scanValue, setScanValue] = useState('');
  const modalRef = useRef(null);
  const navigate = useNavigate();

  const handleScanChange = (e) => {
    setScanValue(e.target.value);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleScan();
    } else {
      modalRef.current && modalRef.current.focus();
    }
  };

  const handleScan = async () => {
    onBarcodeDetected(scanValue);
    /* Uncomment if you want to look up via API:
    const client = new ProductsClient();
    const scanResults = await client.globalScan(scanValue);
    if (scanResults?.path) {
      setScanValue('');
      navigate(`/${scanResults.path}`);
    }
    */
  };

  return (
    <Modal
      show={true}
      backdrop="static"
      onEntered={() => modalRef.current && modalRef.current.focus()}
      centered
        onHide={() => {
            onClose();
        }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Scan</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>Use a handheld scanner or enter a product/item serial number below:</p>
        <InputGroup>
          <FormControl
            id="scanInput"
            ref={modalRef}
            type="text"
            placeholder="Scan or type code here"
            value={scanValue}
            onChange={handleScanChange}
            onKeyDown={handleKeyPress}
          />
          <Button variant="primary" onClick={handleScan}>
            Submit
          </Button>
        </InputGroup>
      </Modal.Body>
    </Modal>
  );
}

export default ScanModal;
